import {ReactNode, useEffect, useRef, useState} from 'react';
import classNames from 'classnames';

import './styles.scss';

export type SimpleDrawerProps = {
  show: boolean;
  children: ReactNode;
  onClickAway: () => void;
  className?: string;
};
/**
 * A simpler sliding drawer for cases where the Drawer in Shipwell UI breaks
 * everything for unknown reasons.
 */
export function SimpleDrawer({show, children, onClickAway, className}: SimpleDrawerProps) {
  const [renderContent, setRenderContent] = useState(false);

  type TimeoutID = string | number | undefined | NodeJS.Timeout;

  const mountedRef = useRef<{mounted: boolean; timeout: TimeoutID}>({mounted: false, timeout: undefined});

  useEffect(() => {
    mountedRef.current.mounted = true;
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      mountedRef.current.mounted = false;
    };
  });

  useEffect(() => {
    if (show && renderContent) {
      clearTimeout(mountedRef.current.timeout);
      mountedRef.current.timeout = undefined;
    }
    if (show && !renderContent) {
      setRenderContent(true);
    }
    if (!show && renderContent) {
      mountedRef.current.timeout = setTimeout(() => {
        if (mountedRef.current.mounted) {
          setRenderContent(false);
        }
      }, 500);
    }
  }, [show, renderContent]);

  return (
    <div
      className={classNames(
        'sw-simple-drawer-anchor',
        'z-50 absolute inset-y-0 right-0 w-0 overflow-visible',
        {
          'sw-simple-drawer-extended': show,
          'sw-simple-drawer-unextended': !show
        },
        className
      )}
    >
      {renderContent ? <div className="fixed inset-0 bg-sw-boxShadow" onClick={onClickAway} /> : null}
      <div className="sw-simple-drawer_content inset-y0 absolute right-0">{renderContent ? children : null}</div>
    </div>
  );
}
